import {
  createApiRef,
  OpenIdConnectApi,
  ProfileInfoApi,
  BackstageIdentityApi,
  SessionApi,
} from '@backstage/core-plugin-api';

/**
 * La référence de l'API de connexion Authelia, celle que les vues lisent.
 * Son implémentation (l'ApiBlueprint `autheliaAuthApi`) reste dans
 * l'application, `packages/app/src/auth/autheliaAuthApi.ts` : la référence
 * est à part pour que les vues du cœur la lisent sans importer l'application
 * (étape 9c du plan « plateforme d'applications »).
 */
export const autheliaAuthApiRef = createApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
>({
  id: 'auth.authelia.oidc',
});
